import React, { Component } from 'react';
import { observer } from 'mobx-react';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AuthStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';
import WorkStore from '../Kanban/WorkStore';
import './users.css'

const NotificationItem = observer(class NotificationItem extends Component {
    constructor(props) {
        super(props);

        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.openWork = this.openWork.bind(this);
    }

    handleDeleteClick() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Notification/DeleteNotification', {
            method: 'POST',
            body: JSON.stringify({ id: this.props.id }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    if (scope.props.onNotifyDeleted) {
                        scope.props.onNotifyDeleted(scope.props.id);
                    }
                }).catch((err) => console.log(err));
            }
        });
    }

    openWork() {
        if (this.props.workId) {
            MainStore.setMaskVisible();
            fetch('api/Work/GetWork?id=' + this.props.workId, {
                method: 'GET',
                body: null,
            }).then(function (res) {
                if (res.status === 401) {
                }
                else {
                    res.json().then((result) => {
                        MainStore.setMaskUnvisible();
                        WorkStore.openWorkDialog(result);
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    render() {
        return (
            <div className="notification-item">
                <MenuItem>
                    <div className="notification-text" onClick={this.openWork}>
                            {this.props.children}
                    </div>
                    <div className="notification-action">
                        <IconButton aria-label="Удалить" onClick={this.handleDeleteClick} size="large"><DeleteIcon fontSize="small" /></IconButton>
                    </div>
                </MenuItem>
            </div>
        );
    }
})

export default NotificationItem;